import "./scripts/card";
import "./scripts/application";

import "./styles/card.scss";
import "./styles/application.scss";
